import React from "react";
import {
  Maximize2,
  Activity,
  MapPin,
} from "lucide-react";

const OperationalGallery = () => {
const assets = [
  {
    url: "https://focusinspectiontechnology.com/static/media/g4.e654ecd0972907f69cf5.jpeg",
    title: "Ultrasonic Testing",
    application: "Weld Inspection",
    category: "PAUT / TOFD Inspection",
  },
  {
    url: "https://evalndt.com/static/media/Step6.6dc1044a3e0c8a99f299.png",
    title: "Inspection Software",
    application: "Digital NDT Reporting",
    category: "NDT Software",
  },
  {
    url: "https://focusinspectiontechnology.com/static/media/g5.0d8e1a607829c68b925a.jpeg",
    title: "Refinery Inspection",
    application: "Oil & Gas Plant",
    category: "Asset Integrity",
  },
{
  url: "https://focusinspectiontechnology.com/static/media/Integrity1.97a997f9be9f6c7dbfa7.jpeg",
  title: "Field Deployment",
  application: "Field Operation",
  category: "On-site NDT",
},
];

  return (
    <section
      id="gallery"
      className="py-20 md:py-32 px-4 sm:px-6 bg-white"
    >
      <div className="max-w-6xl mx-auto">

        {/* HEADER */}

        <div className="mb-14 md:mb-20">

          <div className="flex items-center gap-3 mb-3">
            <div className="w-10 h-[2px] bg-orange-600" />
            <span className="text-orange-600 text-xs font-bold uppercase tracking-widest">
              Project Gallery
            </span>
          </div>

          <h2 className="text-3xl sm:text-4xl md:text-6xl font-black text-slate-900">
            Inspection & NDT Field Operations
          </h2>

          <p className="text-slate-500 mt-4 max-w-2xl text-sm leading-relaxed">
            Our team performs non destructive testing, inspection services,
            and asset integrity evaluation for oil & gas, shipyard,
            infrastructure, manufacturing, and offshore projects.
            Below are examples of real inspection environments including
            PAUT, TOFD, ultrasonic testing, and digital inspection systems.
          </p>

        </div>



        {/* GRID */}

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">

     {assets.map((asset, i) => (

  <div
    key={i}
    className="group relative h-[360px] overflow-hidden bg-slate-900"
  >

    <img
      src={asset.url}
      alt={asset.title}
      className="w-full h-full object-cover group-hover:scale-110 transition duration-500 opacity-80 group-hover:opacity-100"
    />


    {/* category */}

    <div className="absolute top-3 left-3 bg-orange-600 text-white text-[10px] px-2 py-1 uppercase font-bold">
      {asset.category}
    </div>


    {/* bottom */}

    <div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-black/80 to-transparent">

      <p className="text-orange-400 text-xs uppercase tracking-wider">
        {asset.application}
      </p>

      <h3 className="text-white font-bold text-lg">
        {asset.title}
      </h3>

    </div>


    {/* icon */}

    <div className="absolute top-3 right-3 opacity-0 group-hover:opacity-100 transition">

      <div className="bg-white/20 p-2">
        <Maximize2 size={14} className="text-white" />
      </div>

    </div>

  </div>

))}

        </div>



        {/* SEO TEXT */}

        <div className="mt-16 max-w-3xl text-sm text-slate-500 leading-relaxed">

          <p>
            Focus NDT Group provides inspection and non destructive testing
            services using advanced ultrasonic testing, phased array UT,
            TOFD, magnetic particle testing, dye penetrant testing,
            and visual inspection methods. Our inspection teams work on
            pipelines, pressure vessels, offshore platforms, shipyard
            structures, and heavy engineering components worldwide.
          </p>

        </div>



        {/* STATS */}

        <div className="mt-14 grid grid-cols-3 gap-6 text-center">

          <div>
            <p className="text-2xl font-black text-slate-900">
              500+
            </p>
            <p className="text-xs text-slate-400 uppercase">
              Inspections Completed
            </p>
          </div>

          <div>
            <p className="text-2xl font-black text-slate-900">
              1M+
            </p>
            <p className="text-xs text-slate-400 uppercase">
              Data Points Recorded
            </p>
          </div>

          <div>
            <p className="text-2xl font-black text-slate-900">
              10+
            </p>
            <p className="text-xs text-slate-400 uppercase">
              Active Projects
            </p>
          </div>

        </div>

      </div>
    </section>
  );
};

export default OperationalGallery;